import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { NotificationService } from '../services/notification.service';
import * as jwt_decode from 'jwt-decode';
import {  PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss']
})
export class NotificationListComponent implements OnInit {

currentUser: any;
organizationId: string;
databaseId: string;
responseHolder: any;

NotificationList: any = [];

 pageSizeOptions: number[] = [10, 20, 50, 100];
 paginatorTotalLength: any;
 pageIndex: any;
 pageSize: any;

 pageModelData = {
  pageIndex: 0,
  pageSize: 10,
  searchValue: '',
};  

TotalNotification:number=0;
UnreadNotification:number=0;
value = '';
OfficeIDList: any=[];
myOfficeID: any;

  constructor(    
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private router: Router,
    private statusConstant: StatusConstant,    
    private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
  

var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }

  ngOnInit(): void {

    sessionStorage.setItem('HeaderModuleName', 'Notifications');
    this._dataSharingService.sendSelectedModuleName('Notifications');

    this.GetUnreadNotificationsCount();
    this.getNotificationList(this.pageModelData);
    this.cdr.detectChanges();
  }

  getShortName(fullName) {
    var name = fullName;
    if(name !=null || name!=undefined){
     return fullName.split(' ').map(n => n[0]).join('');
    }else{
      return '';
    }   
  }

   GetUnreadNotificationsCount() {
    var ReqModel ={
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList:this.OfficeIDList,
      OfficeID:this.myOfficeID
    }   
    this.notificationService.GetUnreadNotificationsCount(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {         
          this.UnreadNotification=response.data;
        }
        else {
        }
      }
      else {
      }
    });
  
  }

  getNotificationList(pageData) {
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    var ReqModel ={
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      searchKey: this.pageModelData.searchValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList:this.OfficeIDList
    }
    this.loaderService.show();
    this.notificationService.getNotificationList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          this.loaderService.hide();
          this.NotificationList = this.responseHolder.data.notificationDetailModelList;
          if(this.NotificationList.length>0){
            this.NotificationList=this.NotificationList.filter((v,i,a)=>a.findIndex(t=>(t.notificationMappingId === v.notificationMappingId))===i)
          }         
          this.TotalNotification=response.data.totalcount;
          this.paginatorTotalLength = response.data.totalcount;
          this.pageModelData.pageIndex = response.data.pageIndex;
          this.pageIndex = response.data.pageIndex;
          this.pageSize = pageData.pageSize;         
        }
        else {
          this.loaderService.hide();
          this.NotificationList=[];
          this.paginatorTotalLength=0;
        }
      }
      else {
        this.loaderService.hide();
        this.NotificationList=[];
        this.paginatorTotalLength=0;
      }
    });
  
  }

  pageEventPropogate(pageData: PageEvent) {
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue;
    this.getNotificationList(this.pageModelData);
  }

  Search(filterValue) {
    this.pageModelData.searchValue=filterValue.trim();
    this.getNotificationList(this.pageModelData);
  }

  Markallasread() {
    var ReqModel ={
      notificationMapIds:[],      
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeIDList:this.OfficeIDList,
      OfficeID:this.myOfficeID
    }
    this.loaderService.show();
    this.notificationService.MarkUnreadNotifications(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
          this.loaderService.hide();      
          this.GetUnreadNotificationsCount();
          this.getNotificationList(this.pageModelData);
          this._dataSharingService.sendNotificationRead(true);
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });  
  }
  
  MarkPerticularRead(notification) {    
    if(notification.isRead==false) {
     var notificationMapIds=[];
     notificationMapIds.push(notification.notificationMappingId);
      var ReqModel ={
        notificationMapIds:notificationMapIds,  
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        OfficeIDList:this.OfficeIDList,
        OfficeID:this.myOfficeID
      }
      this.loaderService.show();
      this.notificationService.MarkUnreadNotifications(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
            this.loaderService.hide();
            this.GetUnreadNotificationsCount();
            this.getNotificationList(this.pageModelData);
            this._dataSharingService.sendNotificationRead(true);
          }
          else {
            this.loaderService.hide();
          }
        }
        else {
          this.loaderService.hide();
        }
      });    
    }

    if(notification.moduleId=="1"){
      this.router.navigate(['/core/listing']);
    }
    if(notification.moduleId=="2"){
      this.router.navigate(['/company/listing']);
    }
    if(notification.moduleId=="3"){
      this.router.navigate(['/contact/listing']);
    }
    if(notification.moduleId=="4"){
      this.router.navigate(['/esignature']);
    }
    if(notification.moduleId=="7" || notification.moduleId=="8" || notification.moduleId=="9"){
      this.router.navigate(['/esignature/inbox']);
    }
  }

}
